import { createAction } from "@reduxjs/toolkit";
import buildUrl from "build-url-ts";
import _, { create } from "lodash";
import axios from "axios";
import { takeEvery, call, put, select, takeLatest } from "redux-saga/effects";

import { ADD_ASSETS_TO_CONVERSATION_ON_SERVER, ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER, ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_FAILED, ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_SUCCEDDED, ADD_OPPORTUNITY_TO_SHARE, ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_FAILED, ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_SUCCEDDED, ADDING_OPPORTUNITY_TO_SHARE_FAILED, ADDING_OPPORTUNITY_TO_SHARE_SUCCEEDED, CONVERSATION_ADD_ASSETS, CONVERSATION_MOVE_ASSET_TO_SECTION, CONVERSATION_REARRANGE_ASSETS, CONVERSATION_REMOVE_ASSETS, CONVERSATION_UPDATE_ASSET_METADATA, CONVERSATION_UPDATE_PROPERTY, CREATE_CONVERSATION_REQUEST, CREATE_CONVERSATION_SECTION_REQUEST, CREATING_CONVERSATION_FAILED, CREATING_CONVERSATION_SUCCEEDED, DELETE_CONVERSATION_REQUEST, DELETING_CONVERSATION_FAILED, DELETING_CONVERSATION_SUCCEEDED, EDIT_CONVERSATION_REQUEST, FETCH_ASSETS_FOR_CONVERSATION_REQUEST, FETCH_ASSETS_FOR_SECTION, FETCH_CONVERSATION_ASSET_ANALYTICS_REQUEST, FETCH_CONVERSATION_ASSETS_REQUEST, FETCH_CONVERSATION_EVENTS, FETCH_CONVERSATION_REQUEST, FETCH_CONVERSATION_SECTION_REQUEST, FETCH_CONVERSATIONS_REQUEST, FETCH_MESSAGE_REQUEST, FETCH_RECIPIENT_INFO_FOR_CONVERSATION_REQUEST, FETCH_RECIPIENTS_FOR_CONVERSATION_REQUEST, FETCHING_ASSETS_FOR_CONVERSATION_FAILED, FETCHING_ASSETS_FOR_CONVERSATION_SUCCEDDED, FETCHING_ASSETS_FOR_SECTION_FAILED, FETCHING_ASSETS_FOR_SECTION_SUCCEEDED, FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED, FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEEDED, FETCHING_CONVERSATION_ASSETS_FAILED, FETCHING_CONVERSATION_ASSETS_SUCCEEDED, FETCHING_CONVERSATION_EVENTS_FAILED, FETCHING_CONVERSATION_EVENTS_SUCCEEDED, FETCHING_CONVERSATION_FAILED, FETCHING_CONVERSATION_SECTION_FAILED, FETCHING_CONVERSATION_SECTION_SUCCEEDED, FETCHING_CONVERSATION_SUCCEEDED, FETCHING_CONVERSATIONS_FAILED, FETCHING_CONVERSATIONS_SUCCEEDED, FETCHING_MESSAGE_FAILED, FETCHING_MESSAGE_SUCCEEDED, FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_FAILED, FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_SUCCEDDED, FETCHING_RECIPIENTS_FOR_CONVERSATION_FAILED, FETCHING_RECIPIENTS_FOR_CONVERSATION_SUCCEDDED, INVALIDATE_CONVERSATION_EDIT_STATE, INVALIDATE_CONVERSATION_STATE, INVALIDATE_RESHARE, MOVE_CONVERSATION_SECTION_REQUEST, REMOVE_CONVERSATION_SECTION_REQUEST, REMOVE_OPPORTUNITY_FROM_SHARE, REMOVING_OPPORTUNITY_FROM_SHARE_FAILED, REMOVING_OPPORTUNITY_FROM_SHARE_SUCCEEDED, RESEND_CONVERSATION_REQUEST, RESENDING_CONVERSATION_SUCCEEDED, SEARCHING_ENTITIES_IN_SHARE_FAILED, SEARCHING_ENTITIES_IN_SHARE_REQUEST, SEARCHING_ENTITIES_IN_SHARE_SUCCEEDED, TOGGLE_VISITOR_SESSION, UPDATE_CONVERSATION_RECIPENT_REQUEST, UPDATE_CONVERSATION_REQUEST, UPDATE_CONVERSATION_SECTION_REQUEST, UPDATING_CONVERSATION_FAILED, UPDATING_CONVERSATION_RECIPENT_FAILED, UPDATING_CONVERSATION_RECIPENT_SUCCEEDED, UPDATING_CONVERSATION_SUCCEEDED, INVALIDATE_CREATE_CONVERSATION } from "./actionTypes";
import { AddAssetToConversationErrorResponse, AddAssetToConversationRequest, AddAssetToConversationResponse, AddOpportunityToShare, AddOpportunityToShareErrorResponse, AddOpportunityToShareResponse, ArrangeAssetInConversationRequest, Conversation, CreateConversationErrorResponse, CreateConversationRequest, CreateConversationResponse, CreateConversationSectionRequest, DeleteConversationErrorResponse, DeleteConversationRequest, DeleteConversationResponse, FetchAssetsForConversationErrorResponse, FetchAssetsForConversationRequest, FetchAssetsForConversationResponse, FetchAssetsForSection, FetchAssetsForSectionErrorResponse, FetchAssetsForSectionResponse, FetchConversationAssetAnalyticsErrorResponse, FetchConversationAssetAnalyticsRequest, FetchConversationAssetAnalyticsResponse, FetchConversationAssetsErrorResponse, FetchConversationAssetsResponse, FetchConversationErrorResponse, FetchConversationEventsErrorResponse, FetchConversationEventsRequest, FetchConversationEventsResponse, FetchConversationResponse, FetchConversationSectionErrorResponse, FetchConversationSectionRequest, FetchConversationSectionResponse, FetchConversationsErrorResponse, FetchConversationsRequest, FetchConversationsResponse, FetchingMessageErrorResponse, FetchingMessageResponse, FetchMessageRequest, FetchRecipientInfoErrorResponse, FetchRecipientInfoRequest, FetchRecipientInfoResponse, FetchRecipientsForConversationErrorResponse, FetchRecipientsForConversationRequest, FetchRecipientsForConversationResponse, FethcConversationAssetsRequest, InvalidateReshare, MoveAssetToSectionRequest, MoveConversationSectionRequest, RemoveAssetFromConversationRequest, RemoveConversationSectionRequest, RemoveOpportunityFromConversationErrorResponse, RemoveOpportunityFromConversationRequest, RemoveOpportunityFromConversationResponse, RenameConversationSectionRequest, ResendMessageErrorResponse, ResendMessageRequest, ResendMessageResponse, SearchEntitiesInShareErrorResponse, SearchEntitiesInShareRequest, SearchEntitiesInShareResponse, ToggleVisitorSessionRequest, UpdateAssetMetadataRequest, UpdateConversationErrorResponse, UpdateConversationPropertyRequest, UpdateConversationRecipientErrorResponse, UpdateConversationRecipientRequest, UpdateConversationRecipientResponse, UpdateConversationRequest, UpdateConversationResponse } from "src/types/conversations";
import { RESENDING_CONVERSATION_FAILED } from "src/legacy/redux/actions/actionTypes";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const SHARE_BASE_URL = `${apiUrl}/api/2.0/shares`;
const CONVERSATIONS_BASE_URL = `${apiUrl}/api/2.1/conversations`;
const VISITORS_URL = `${apiUrl}/api/2.0/visitors/`;

//fetch list of Conversations 
export const fetchConversations = createAction<FetchConversationsRequest>(FETCH_CONVERSATIONS_REQUEST);
const fetchingConversationsSucceeded = createAction<FetchConversationsResponse>(FETCHING_CONVERSATIONS_SUCCEEDED);
const fetchingConversationsFailed = createAction<FetchConversationsErrorResponse>(FETCHING_CONVERSATIONS_FAILED);

export const fetchConversationsSaga = function* (action: ReturnType<typeof fetchConversations>): any {
  const url = buildUrl(SHARE_BASE_URL, {
    path: '/all'
  });

  const fetchConversationsApi = () => {
    return axios({
      method: 'POST',
      url: url,
      data: action.payload
    }).then((response) => response.data);
  }

  try {
    const response = yield call(fetchConversationsApi);
    yield put(fetchingConversationsSucceeded({ response }));
    
  } catch (error) {
    yield put(fetchingConversationsFailed({ error: error }));
  }
}

// Create new conversation

export const createConversation = createAction<CreateConversationRequest>(CREATE_CONVERSATION_REQUEST);
const creatingConversationSucceeded = createAction<CreateConversationResponse>(CREATING_CONVERSATION_SUCCEEDED);
const creatingConversationFailed = createAction<CreateConversationErrorResponse>(CREATING_CONVERSATION_FAILED);

const createConversationSaga = function* (action: ReturnType<typeof createConversation>): any {
  const request = action.payload;

  const createConversationAPI = () => {
    return axios({
      method: 'POST',
      url: CONVERSATIONS_BASE_URL,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createConversationAPI);
    yield put(creatingConversationSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(creatingConversationFailed({ error: error }));
  }

}
// invalidate conversations
export const invalidateCreateConversation = createAction<void>(INVALIDATE_CREATE_CONVERSATION);

//Fetch Collection
export const fetchConversation = createAction<string>(FETCH_CONVERSATION_REQUEST);
const fetchingConversationSucceeded = createAction<FetchConversationResponse>(FETCHING_CONVERSATION_SUCCEEDED);
const fetchingConversationFailed = createAction<FetchConversationErrorResponse>(FETCHING_CONVERSATION_FAILED);

const fetchConversationSaga = function* (action: ReturnType<typeof fetchConversation>): any {
  const id = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.0/shares/${id}`
  });

  const fetchConversationApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchConversationApi);
    yield put(fetchingConversationSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingConversationFailed({ id: id, error: error }));
  }
};

export const editConversation = createAction<Conversation>(EDIT_CONVERSATION_REQUEST);

/**
 * Action creator for fetching assets for a conversation.
 * 
 * This action is dispatched to initiate the process of fetching assets
 * associated with a specific conversation. It uses the `createAction` 
 * utility to create an action with the type `FETCH_ASSETS_FOR_CONVERSATION_REQUEST`.
 * 
 * @param {FetchAssetsForConversationRequest} payload - The request payload containing
 * the necessary information to fetch the assets for the conversation.
 * 
 * @returns {Action<FetchAssetsForConversationRequest>} The action object with the type
 * `FETCH_ASSETS_FOR_CONVERSATION_REQUEST` and the provided payload.
 */
export const fetchAssetsForConversation = createAction<FetchAssetsForConversationRequest>(FETCH_ASSETS_FOR_CONVERSATION_REQUEST);
const fetchingAssetsForConversationSucceeded = createAction<FetchAssetsForConversationResponse>(FETCHING_ASSETS_FOR_CONVERSATION_SUCCEDDED);
const fetchingAssetsForConversationFailed = createAction<FetchAssetsForConversationErrorResponse>(FETCHING_ASSETS_FOR_CONVERSATION_FAILED);

const fetchAssetsForConversationSaga = function* (action: ReturnType<typeof fetchAssetsForConversation>): any {
  const {id} = action.payload as FetchAssetsForConversationRequest;
    const url = buildUrl(apiUrl,{
      path: `api/2.2/shares/${id}/assets`});


  const fetchAssetsForConversationApi = () => {
    return axios({
      method: 'GET',
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetsForConversationApi);
    yield put(fetchingAssetsForConversationSucceeded({
      conversation: id,
      response: response
    }));
  } catch (error) {
    yield put(fetchingAssetsForConversationFailed({ id: id, error: error }));
  }
};

// export const fetchConversationAssets = 

export const fetchRecipientsForConversation = createAction<FetchRecipientsForConversationRequest>(FETCH_RECIPIENTS_FOR_CONVERSATION_REQUEST);
const fetchingRecipientsForConversationSucceeded = createAction<FetchRecipientsForConversationResponse>(FETCHING_RECIPIENTS_FOR_CONVERSATION_SUCCEDDED);
const fetchingRecipientsForConversationFailed = createAction<FetchRecipientsForConversationErrorResponse>(FETCHING_RECIPIENTS_FOR_CONVERSATION_FAILED);

const fetchRecipientsForConversationSaga = function* (action: ReturnType<typeof fetchRecipientsForConversation>): any {
  const {id, page, sortBy, orderBy, filter} = action.payload as FetchRecipientsForConversationRequest;

  const url = buildUrl(apiUrl, {
    path: `api/2.0/shares/${id}/recipients`
  });

  const params = {
    page: page,
    sortBy: sortBy,
    orderBy: orderBy,
    type: filter
  }

  const fetchRecipientsForConversationApi = () => {
    return axios({
      method: 'GET',
      url: url,
      params: params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchRecipientsForConversationApi);
    yield put(fetchingRecipientsForConversationSucceeded({
      conversation: id,
      response: response
    }));
  } catch (error) {
    yield put(fetchingRecipientsForConversationFailed({ id: id, error: error }));
  }
};

//recipients info
export const fetchRecipientInfo = createAction<FetchRecipientInfoRequest>(FETCH_RECIPIENT_INFO_FOR_CONVERSATION_REQUEST);
const fetchingRecipientInfoSucceeded = createAction<FetchRecipientInfoResponse>(FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_SUCCEDDED);
const fetchingRecipientInfoFailed = createAction<FetchRecipientInfoErrorResponse>(FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_FAILED);

const fetchRecipientInfoSaga = function* (action: ReturnType<typeof fetchRecipientInfo>): any {
  const { shareId, recipientId } = action.payload as FetchRecipientInfoRequest;

  const url = buildUrl(CONVERSATIONS_BASE_URL, {
    path: `${shareId}/recipients/${recipientId}/activities`
  })

  const fetchRecipientInfoApi = () => {
    return axios({
      method: 'GET',
      url: url
    })
    .then(response => response.data);
  }

  try {
    const response = yield call(fetchRecipientInfoApi);
    yield put(fetchingRecipientInfoSucceeded({
      shareId,
      recipientId,
      response
    }));
  } catch (error) {
    yield put(fetchingRecipientInfoFailed({ shareId, recipientId, error }));
  }
}

//Update Session
export const toggleVisitorSession = createAction<ToggleVisitorSessionRequest>(TOGGLE_VISITOR_SESSION);

const toggleVisitorSessionSaga = function* (action: ReturnType<typeof toggleVisitorSession>): any {
  const { visitorSessionId, conversationId, exclusion, recipientId } = action.payload;

  const toggleVisitorSessionApi = () => {
  const url = buildUrl(VISITORS_URL, {
    path: `/${visitorSessionId}/exclusion/shares/${conversationId}`
  });
  const queryParams = {
    exclusion: exclusion
  }
  return axios({
    method: 'PUT',
    url: url,
    params: queryParams
  }).then((response) => response.data);
}

try {
  const response = yield call(toggleVisitorSessionApi)
  yield put(fetchingRecipientInfoSucceeded({
    shareId: conversationId,
    recipientId: recipientId,
    response
  }))
} catch (error) {
  console.log(error);
  
}
}

// Converstion section
export const fetchConversationSection = createAction<FetchConversationSectionRequest>(FETCH_CONVERSATION_SECTION_REQUEST);
const fetchingConversationSectionSucceeded = createAction<FetchConversationSectionResponse>(FETCHING_CONVERSATION_SECTION_SUCCEEDED);
const fetchingConversationSectionFailed = createAction<FetchConversationSectionErrorResponse>(FETCHING_CONVERSATION_SECTION_FAILED);

const fetchConversationSectionSaga = function* (action: ReturnType<typeof fetchConversationSection>): any {
  const { conversation, section } = action.payload as FetchConversationSectionRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/2.2/shares/sections/${section}`
  });

  const fetchConversationSectionApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchConversationSectionApi);
    yield put(fetchingConversationSectionSucceeded({
      conversation: conversation,
      section: section,
      response: response
    }));
  } catch (error) {
    yield put(fetchingConversationSectionFailed({ conversation: conversation, section: section, error: error }));
  }
};

//Edit conversation
export const updateConversationProperty = createAction<UpdateConversationPropertyRequest>(CONVERSATION_UPDATE_PROPERTY);
export const invalidateEditConversation = createAction<string>(INVALIDATE_CONVERSATION_EDIT_STATE);

export const createSection = createAction<CreateConversationSectionRequest>(CREATE_CONVERSATION_SECTION_REQUEST);
export const renameSection = createAction<RenameConversationSectionRequest>(UPDATE_CONVERSATION_SECTION_REQUEST);
export const removeSection = createAction<RemoveConversationSectionRequest>(REMOVE_CONVERSATION_SECTION_REQUEST);
export const moveSection = createAction<MoveConversationSectionRequest>(MOVE_CONVERSATION_SECTION_REQUEST);

const createConversationSectionSaga = function* (action: ReturnType<typeof createSection>): any {
  const { conversation } = action.payload;

  const existingSections = yield select((state) => _.get(state, 'conversations.edit.sections') || []);

  if (existingSections.length > 1) {
    return;
  }

  const existingAssets = yield select((state) => {
    return _.get(state, 'conversations.edit.entities') || [];
  });

  if (_.size(existingAssets) > 0) {
    yield put(createSection({
      conversation: conversation,
      name: 'Others'
    }));

    yield put(addAssetToConversation({
      conversation: conversation,
      section: 1,
      assets: existingAssets,
      addAt: 'start'
    }));
  }
}

export const addAssetToConversation = createAction<AddAssetToConversationRequest>(CONVERSATION_ADD_ASSETS);
export const moveAsset = createAction<ArrangeAssetInConversationRequest>(CONVERSATION_REARRANGE_ASSETS);
export const moveAssetToSection = createAction<MoveAssetToSectionRequest>(CONVERSATION_MOVE_ASSET_TO_SECTION);
export const removeAssetFromConversation = createAction<RemoveAssetFromConversationRequest>(CONVERSATION_REMOVE_ASSETS);
export const updateAssetMetadata = createAction<UpdateAssetMetadataRequest>(CONVERSATION_UPDATE_ASSET_METADATA);

const moveAssetToSectionSaga = function* (action: ReturnType<typeof moveAssetToSection>): any {
  const { conversation, source, target, asset } = action.payload;

  yield put(removeAssetFromConversation({
    conversation: conversation,
    section: source,
    asset: asset.id
  })
  )

  const targetSection = yield select((state) => state.conversations.edit.sections[target]);

  if (!targetSection.loaded) {
    yield call(fetchConversationSectionSaga, fetchConversationSection({
      conversation: conversation,
      section: targetSection.item.id
    }));
  }

  yield put(addAssetToConversation({
    conversation: conversation,
    section: target,
    assets: [asset],
    addAt: 'start'
  }));

}

//Update Collection
export const updateConversation = createAction<UpdateConversationRequest>(UPDATE_CONVERSATION_REQUEST);
const updatingConversationSucceeded = createAction<UpdateConversationResponse>(UPDATING_CONVERSATION_SUCCEEDED);
const updatingConversationFailed = createAction<UpdateConversationErrorResponse>(UPDATING_CONVERSATION_FAILED);

const updateConversationSaga = function* (action: ReturnType<typeof updateConversation>): any {
  const { id, request } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.2/shares/${id}`
  });

  const updateConversationApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateConversationApi);
    yield put(updatingConversationSucceeded({ response: response }));
  } catch (error) {
    yield put(updatingConversationFailed({ id: id, error: error }));
  }
};

//Add asset to conversation in the backend
export const addAssetsToConversationOnServer = createAction<AddAssetToConversationRequest>(ADD_ASSETS_TO_CONVERSATION_ON_SERVER);
const addAssetsToConversationOnServerSuccedded = createAction<AddAssetToConversationResponse>(ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_SUCCEDDED);
const addAssetsToConversationnServerFailed = createAction<AddAssetToConversationErrorResponse>(ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_FAILED);


const addAssetToConversationOnServerSaga = function* (action: ReturnType<typeof addAssetsToConversationOnServer>): any {
  const { assets, conversation } = action.payload;

  const request = (assets || []).map((asset) => {
    return asset.id;
  });

  const addAssetToCollectionApi = () => {
    return axios({
      method: 'PUT',
      url: `${apiUrl}/api/2.0/shares/${conversation}/assets`, 
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(addAssetToCollectionApi);
    yield put(addAssetsToConversationOnServerSuccedded({
      conversation: conversation,
      response: response
    }));
  } catch (error) {
    yield put(addAssetsToConversationnServerFailed({conversation, error: error }));
  }
};

export const addAssetsToConversationSectionOnServer = createAction<AddAssetToConversationRequest>(ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER);
const addAssetsToConversationSectionOnServerSuccedded = createAction<AddAssetToConversationResponse>(ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_SUCCEDDED);
const addAssetsToConversationSectionOnServerFailed = createAction<AddAssetToConversationErrorResponse>(ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_FAILED);

const addAssetsToSectionOnServerSaga = function* (action: ReturnType<typeof addAssetsToConversationSectionOnServer >): any {
  const { conversation, section, assets } = action.payload;

  const sectionId = yield select((state) => {
    const conversationsItem  = _.get(state, `conversations.conversation[${conversation}].item`);
    if(!conversationsItem){
      return null;
    }

    const sectionId = _.get(conversationsItem, `sections[${section}].item.id`);
    return sectionId;
  });

  if(sectionId === null){
    return;
  }


  const request = (assets || []).map((asset) => {
    return asset.id;
  });

  const addAssetsToSectionApi = () => {
    return axios({
      method: 'PUT',
      url: `${apiUrl}/api/2.0/shares/sections/${sectionId}/assets`, 
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(addAssetsToSectionApi);
    yield put(addAssetsToConversationSectionOnServerSuccedded({
      conversation: conversation,
      section: section,
      response: response
    }));
  } catch (error) {
    yield put(addAssetsToConversationSectionOnServerFailed({conversation, section, error: error }));
  }
};

export const removeOpportunityFromConversation = createAction<RemoveOpportunityFromConversationRequest>(REMOVE_OPPORTUNITY_FROM_SHARE);
const removingOpportunityFromConversationSucceeded = createAction<RemoveOpportunityFromConversationResponse>(REMOVING_OPPORTUNITY_FROM_SHARE_SUCCEEDED);
const removingOpportunityFromConversationFailed = createAction<RemoveOpportunityFromConversationErrorResponse>(REMOVING_OPPORTUNITY_FROM_SHARE_FAILED);

const removeOpportunityFromConversationSaga = function* (action: ReturnType<typeof removeOpportunityFromConversation>): any {
  const { conversationId, opportunityId } = action.payload;

  const url = buildUrl(SHARE_BASE_URL, {
    path: `${conversationId}/opportunity/${opportunityId}`
  });

  const removeOpportunityFromConversationApi = () => {
    return axios({
      method: 'DELETE',
      url: url
    }).then((response) => response.data);
  };

  try {
    yield call(removeOpportunityFromConversationApi);
    yield put(removingOpportunityFromConversationSucceeded({ conversationId, opportunityId }));
  } catch (error) {
    yield put(removingOpportunityFromConversationFailed({ conversationId, opportunityId, error: error }));
  }
}

export const updateConversationRecipient = createAction<UpdateConversationRecipientRequest>(UPDATE_CONVERSATION_RECIPENT_REQUEST);
const updatingConversationRecipientSucceeded = createAction<UpdateConversationRecipientResponse>(UPDATING_CONVERSATION_RECIPENT_SUCCEEDED);
const updatingConversationRecipientFailed = createAction<UpdateConversationRecipientErrorResponse>(UPDATING_CONVERSATION_RECIPENT_FAILED);

const updateConversationRecipientSaga = function* (action: ReturnType<typeof updateConversationRecipient>): any {
  const { conversationId, recipientId, access } = action.payload;

  const url = buildUrl(SHARE_BASE_URL, {
    path: `${conversationId}/recipient/${recipientId}/${access}`
  });

  const  updateConversationRecipientApi = () => {
    return axios({
      method: access === 'activate' ? 'PUT' : 'DELETE',
      url: url,
    })
      .then(response => response.data)
  }

  try {
    const response = yield call(updateConversationRecipientApi);
    yield put(updatingConversationRecipientSucceeded({
      conversationId,
      recipientId,
      response,
    }))
  } catch (error) {
    yield put(updatingConversationRecipientFailed({
      conversationId,
      recipientId,
      error
    }))
  }
}

export const fetchConversationEvents = createAction<FetchConversationEventsRequest>(FETCH_CONVERSATION_EVENTS);
const fetchingConversationEventsSucceeded = createAction<FetchConversationEventsResponse>(FETCHING_CONVERSATION_EVENTS_SUCCEEDED);
const fetchingConversationEventsFailed = createAction<FetchConversationEventsErrorResponse>(FETCHING_CONVERSATION_EVENTS_FAILED);

const fetchConversationEventsSaga = function* (action: ReturnType<typeof fetchConversationEvents>): any {
  let { request, page } = action.payload;

  const params = {
    page: page,
    limit: 20
  };

  const url = buildUrl(SHARE_BASE_URL, {
    path: '/events'
  });
  if(request.eventTypes.includes('all')) {
    request = {
      ...request,
      eventTypes:[]
    }
  }
  const fetchConversationEventsApi = () => {
    return axios({
      method: 'POST',
      url: url,
      data: request,
      params
    }).then((response) => response.data);
  }

  try {
    const response = yield call(fetchConversationEventsApi);
    yield put(fetchingConversationEventsSucceeded({request, data: response }));
  } catch (error) {
    yield put(fetchingConversationEventsFailed({request, error: error }));
  }
}

export const searchEntitiesInShare = createAction<SearchEntitiesInShareRequest>(SEARCHING_ENTITIES_IN_SHARE_REQUEST);
const searchingEntitiesInShareSucceeded = createAction<SearchEntitiesInShareResponse>(SEARCHING_ENTITIES_IN_SHARE_SUCCEEDED);
const searchingEntitiesInShareFailed = createAction<SearchEntitiesInShareErrorResponse>(SEARCHING_ENTITIES_IN_SHARE_FAILED);

const searchEntitiesInShareSaga = function* (action: ReturnType<typeof searchEntitiesInShare>): any {
  const { shareId, query } = action.payload;
  const url = buildUrl(SHARE_BASE_URL, {
    path: `${shareId}/search`
  });

  const params = {
    query: query
  }
  const searchEntitiesInShareApi = () => {
    return axios({
      method: 'GET',
      url: url,
      params: params
    }).then((response) => response.data);
  }
  try {
    const response = yield call(searchEntitiesInShareApi);
    yield put(searchingEntitiesInShareSucceeded({shareId, response: response }));
  } catch (error) {
    yield put(searchingEntitiesInShareFailed({shareId, error: error }));
  }
}

export const addOpportunityToShare = createAction<AddOpportunityToShare>(ADD_OPPORTUNITY_TO_SHARE);
const addingOpportunityToShareSucceeded = createAction<AddOpportunityToShareResponse>(ADDING_OPPORTUNITY_TO_SHARE_SUCCEEDED);
const addingOpportunityToShareFailed = createAction<AddOpportunityToShareErrorResponse>(ADDING_OPPORTUNITY_TO_SHARE_FAILED);

const addOpportunityToShareSaga = function* (action: ReturnType<typeof addOpportunityToShare>): any {
  const { conversationId, opportunityId } = action.payload;
  const url = buildUrl(SHARE_BASE_URL, {
    path: `${conversationId}/opportunity`
  });

  const addOpportunityToShareApi = () => {
    return axios({
      method: 'POST',
      url: url,
      data: {id: opportunityId}
    }).then((response) => response.data);
  }

  try {
    const response = yield call(addOpportunityToShareApi);
    yield put(addingOpportunityToShareSucceeded({conversationId, response: response }));
  } catch (error) {
    yield put(addingOpportunityToShareFailed({conversationId, error: error }));
  }
 
}

export const deleteConversation = createAction<DeleteConversationRequest>(DELETE_CONVERSATION_REQUEST);
const deletingConversationSucceeded = createAction<DeleteConversationResponse>(DELETING_CONVERSATION_SUCCEEDED);
const deletingConversationFailed = createAction<DeleteConversationErrorResponse>(DELETING_CONVERSATION_FAILED);

const deleteConversationSaga = function* (action: ReturnType<typeof deleteConversation>): any {
  const { id } = action.payload;

  const url = buildUrl(SHARE_BASE_URL, {
    path: id
  });

  const deleteConversationApi = () => {
    return axios({
      method: 'DELETE',
      url: url
    }).then((response) => response.data);
  }

  try {
    yield call(deleteConversationApi);
    yield put(deletingConversationSucceeded({ id }));
  } catch (error) {
    yield put(deletingConversationFailed({ id, error }));
  }
}

export const fetchMessage = createAction<FetchMessageRequest>(FETCH_MESSAGE_REQUEST)
const fetchingMessageSucceeded = createAction<FetchingMessageResponse>(FETCHING_MESSAGE_SUCCEEDED)
const fetchingMessageFailed = createAction<FetchingMessageErrorResponse>(FETCHING_MESSAGE_FAILED)

const fetchMessageSaga = function* (action: ReturnType<typeof fetchMessage>): any {
  const { shareId } = action.payload;

  const fetchMessageApi = () => {
    const url = buildUrl(SHARE_BASE_URL, {
      path: `${shareId}/conversation`
    });
      return axios({
        method: 'GET',
        url: url
      }).then((response) => response.data);
  }

  try {
    const response = yield call(fetchMessageApi);
    yield put(fetchingMessageSucceeded({ shareId, response }));
  } catch (error) {
    yield put(fetchingMessageFailed({ shareId, error }));
  }
}

export const resendMessage = createAction<ResendMessageRequest>(RESEND_CONVERSATION_REQUEST)
const resendMessageSucceeded = createAction<ResendMessageResponse>(RESENDING_CONVERSATION_SUCCEEDED)
const resendMessageFailed = createAction<ResendMessageErrorResponse>(RESENDING_CONVERSATION_FAILED)
export const invalidateReshare = createAction<InvalidateReshare>(INVALIDATE_RESHARE)

const resendMessageSaga = function* (action: ReturnType<typeof resendMessage>): any {
  const { conversationId, messageId, toAddresses } = action.payload;
  const url = buildUrl(CONVERSATIONS_BASE_URL, {
    path: `${messageId}/resend`
  });
  const resendMessageApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: {
        toAddresses
      }
    }).then((response) => response.data);
  }
  try {
    yield call(resendMessageApi);
    yield put(resendMessageSucceeded({ conversationId }));
  } catch (error) {
    yield put(resendMessageFailed({ conversationId, error }));
  }
}

export const fetchConversationAssetAnalytics = createAction<FetchConversationAssetAnalyticsRequest>(FETCH_CONVERSATION_ASSET_ANALYTICS_REQUEST);
const fetchingConversationAssetAnalyticsSucceeded = createAction<FetchConversationAssetAnalyticsResponse>(FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEEDED);
const fetchingConversationAssetAnalyticsFailed = createAction<FetchConversationAssetAnalyticsErrorResponse>(FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED);

const fetchConversationAssetAnalyticsSaga = function* (action: ReturnType<typeof fetchConversationAssetAnalytics>): any {
  const { conversationId, assetId, sectionId, type } = action.payload;

  const fetchConversationAssetAnalyticsApi = () => {
    let url = buildUrl(SHARE_BASE_URL, {
      path: `${conversationId}/assets/${assetId}/analytics`
    });

    var params = {
      type: type
    }

    return axios({
      method: 'GET',
      url: url,
      params: params
    })
      .then(response => response.data);
  }

  try {
    const response = yield call(fetchConversationAssetAnalyticsApi);
    yield put(fetchingConversationAssetAnalyticsSucceeded({ conversationId, assetId, sectionId, response }));
  } catch (error) {
    yield put(fetchingConversationAssetAnalyticsFailed({ conversationId, assetId, sectionId, error }));
  }
}

export const invalidateConversation = createAction<void>(INVALIDATE_CONVERSATION_STATE);
//NOTE: as per discussions with team having an entirely separate saga for fething conversation assets and sections as 
// the new end point (2.2) does not return the total time spent and etc
export const fetchConversationAssets = createAction<FethcConversationAssetsRequest>(FETCH_CONVERSATION_ASSETS_REQUEST);
const fetchingConversationAssetsSucceeded = createAction<FetchConversationAssetsResponse>(FETCHING_CONVERSATION_ASSETS_SUCCEEDED);
const fetchingConversationAssetsFailed = createAction<FetchConversationAssetsErrorResponse>(FETCHING_CONVERSATION_ASSETS_FAILED);

const fetchConversationAssetsSaga = function* (action: ReturnType<typeof fetchAssetsForConversation>): any {
  const {id, type} = action.payload as FethcConversationAssetsRequest;
  const url = buildUrl(apiUrl, {
    path: `api/2.0/shares/${id}/assets`,
    queryParams: {
      type,
    }
  });

  const fetchAssetsForConversationApi = () => {
    return axios({
      method: 'GET',
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetsForConversationApi);
    yield put(fetchingConversationAssetsSucceeded({
      conversation: id,
      response: response
    }));
  } catch (error) {
    yield put(fetchingConversationAssetsFailed({ id: id, error: error }));
  }
};

export const fetchAssetsForSections = createAction<FetchAssetsForSection>(FETCH_ASSETS_FOR_SECTION)
const fetchingAssetsForSectionsSucceeded = createAction<FetchAssetsForSectionResponse>(FETCHING_ASSETS_FOR_SECTION_SUCCEEDED)
const fetchingAssetsForSectionsFailed = createAction<FetchAssetsForSectionErrorResponse>(FETCHING_ASSETS_FOR_SECTION_FAILED)

const fetchAssetsForSectionSaga = function* (action: ReturnType<typeof fetchConversationSection>): any {
  const { conversation, section } = action.payload as FetchAssetsForSection;

  const url = buildUrl(apiUrl, {
    path: `/api/2.0/shares/sections/${section}`
  });

  const fetchConversationSectionApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchConversationSectionApi);
    yield put(fetchingAssetsForSectionsSucceeded({
      conversation: conversation,
      section: section,
      response: response
    }));
  } catch (error) {
    yield put(fetchingAssetsForSectionsFailed({ conversation: conversation, section: section, error: error }));
  }
};


export default function* conversationsSaga() {
  yield takeEvery(CREATE_CONVERSATION_REQUEST, createConversationSaga);
  yield takeEvery(FETCH_CONVERSATION_REQUEST, fetchConversationSaga);
  yield takeEvery(FETCH_ASSETS_FOR_CONVERSATION_REQUEST, fetchAssetsForConversationSaga);
  yield takeEvery(FETCH_RECIPIENTS_FOR_CONVERSATION_REQUEST, fetchRecipientsForConversationSaga);
  yield takeEvery(FETCH_CONVERSATION_SECTION_REQUEST, fetchConversationSectionSaga);

  yield takeEvery(CONVERSATION_MOVE_ASSET_TO_SECTION, moveAssetToSectionSaga);
  yield takeEvery(CREATE_CONVERSATION_SECTION_REQUEST, createConversationSectionSaga);
  yield takeEvery(UPDATE_CONVERSATION_REQUEST, updateConversationSaga);

  yield takeEvery(ADD_ASSETS_TO_CONVERSATION_ON_SERVER, addAssetToConversationOnServerSaga);
  yield takeEvery(ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER, addAssetsToSectionOnServerSaga);

  yield takeEvery(FETCH_CONVERSATIONS_REQUEST, fetchConversationsSaga);

  yield takeEvery(REMOVE_OPPORTUNITY_FROM_SHARE, removeOpportunityFromConversationSaga);
  yield takeEvery(FETCH_RECIPIENT_INFO_FOR_CONVERSATION_REQUEST, fetchRecipientInfoSaga);
  yield takeEvery(UPDATE_CONVERSATION_RECIPENT_REQUEST, updateConversationRecipientSaga);
  yield takeEvery(TOGGLE_VISITOR_SESSION, toggleVisitorSessionSaga);

  yield takeEvery(FETCH_CONVERSATION_EVENTS, fetchConversationEventsSaga);
  yield takeLatest(SEARCHING_ENTITIES_IN_SHARE_REQUEST, searchEntitiesInShareSaga);
  yield takeEvery(ADD_OPPORTUNITY_TO_SHARE, addOpportunityToShareSaga);
  yield takeEvery(DELETE_CONVERSATION_REQUEST, deleteConversationSaga);
  yield takeEvery(FETCH_MESSAGE_REQUEST, fetchMessageSaga);
  yield takeEvery(RESEND_CONVERSATION_REQUEST, resendMessageSaga);
  yield takeEvery(FETCH_CONVERSATION_ASSET_ANALYTICS_REQUEST, fetchConversationAssetAnalyticsSaga);
  yield takeEvery(FETCH_CONVERSATION_ASSETS_REQUEST, fetchConversationAssetsSaga);
  yield takeEvery(FETCH_ASSETS_FOR_SECTION, fetchAssetsForSectionSaga);
}
